import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Collapse } from "react-collapse";
// styles
import "./LessonItem.scss";
// assets
import icon__label_video from "../../assets/icons/icon-label--video.svg";
import icon__label_recommended from "../../assets/icons/icon-label--recommended.svg";
import icon__favorite from "../../assets/icons/icon-favorite--2.svg";
import icon__favorited from "../../assets/icons/icon-favorited.svg";
import icon__arrow_right from "../../assets/icons/logo-arrow--right.svg";
import icon__chevron_bottom from "../../assets/icons/icon-chevron--bottom.svg";
import { useFavoriteContext } from "../../context/providers/FavoriteContext";

export function LessonBox(props) {
	return (
		<article className="lessons__item lessons__item--box px-3 py-4 px-md-4 py-md-5">
			<div className="d-flex align-items-center">
				<div className="lessons__item-label d-flex align-items-center fw--600 color--primary">
					<div>
						<img src={icon__label_recommended} alt="Label icon" className="mr-2" />
					</div>
				</div>
			</div>
			<Link
				to={{ pathname: `/lesson/${props.item._id}/${props.item.category}` }}
				className="lessons__item-title d-block mt-1"
			>
				{props.item.title}
			</Link>
			<p className="lessons__item-desc mt-1 mt-md-3">{props.item.description}</p>
			<div className="lessons__item-buttons d-flex mt-3 mt-md-5">
				<button className="btn btn--bordered btn--accent">
					<img src={icon__favorite} alt="" />
				</button>
				<Link
					to={{ pathname: `/lesson/${props.item._id}/${props.item.category}` }}
					className="btn btn--bordered btn--primary lessons__item-link ml-3"
				>
					<span className="pr-2">Start lesson</span>
					<img src={icon__arrow_right} alt="Arrow icon" />
				</Link>
			</div>
		</article>
	);
}

function LessonItem(props) {
	const [isCollapsed, setIsCollapsed] = useState(false);
	const { removeFromFavorite, addToFavorite } = useFavoriteContext();
	const handleClick = (e) => {
		if (props.favoriteKey) {
			removeFromFavorite(props.favoriteKey);
		} else {
			addToFavorite(props.item._id);
		}
	};

	return (
		<article className="lessons__item px-3 py-4 px-md-4 py-md-5">
			<div className="d-flex align-items-center">
				<div className="lessons__item-label d-flex align-items-center fw--600 color--primary">
					<div>
						<img src={icon__label_video} alt="Label icon" className="mr-2" />
					</div>
					Video
				</div>
				{props.item.isNew && <div className="item-badge py-1 px-3 ml-3">New</div>}

				<button
					type="button"
					className={`lessons__item-chevron p-2 ml-auto ${isCollapsed ? "is-opened" : "is-closed"}`}
					onClick={() => setIsCollapsed(!isCollapsed)}
				>
					<img src={icon__chevron_bottom} alt="Collapse lesson item" />
				</button>
			</div>
			<Link
				to={{ pathname: `/lesson/${props.item._id}/${props.item.category}` }}
				className={`lessons__item-title d-block mt-1 ${props.item.isOpened ? "mt-md-3" : "mt-md-2"}`}
				style={{ marginBottom: "16px" }}
			>
				{props.item.title}
			</Link>
			{props.item.thumbnail.date && (
				<span
					className="lessons__item-desc "
					style={{
						marginBottom: "16px",
						fontSize: "16px",
						borderRadius: "1.6rem",
						padding: "0.4rem 1.6rem",
						backgroundColor: "#f4f5ff",
					}}
				>
					{props.item.thumbnail.date}
				</span>
			)}
			<Collapse isOpened={isCollapsed}>
				<p className="lessons__item-desc mt-1 mt-md-3">{props.item.summary}</p>
				<div className="lessons__item-buttons d-flex mt-3 mt-md-5">
					<button className={`btn btn--accent ${props.favoriteKey ? "" : "btn--bordered"}`} onClick={handleClick}>
						<div>{props.favoriteKey ? <img src={icon__favorited} alt="" /> : <img src={icon__favorite} alt="" />}</div>
						<span className="ml-2 d-none d-xl-block">
							{props.favoriteKey ? "Remove from favorite" : "Add to favorites"}
						</span>
					</button>
					<Link
						to={{ pathname: `/lesson/${props.item._id}/${props.item.category}` }}
						className="btn btn--bordered btn--primary lessons__item-link ml-3"
					>
						<span className="pr-2">Start lesson</span>
						<img src={icon__arrow_right} alt="Arrow icon" />
					</Link>
				</div>
			</Collapse>
		</article>
	);
}

export default LessonItem;
